import React from 'react';
import { useParams } from 'react-router-dom';

import { MachineCard } from '@/components/MachineCard';
import { useGetUserProfile } from '@/lib/api/orval/target/users/users';
import { errorMessage } from '@/lib/errors';

export function UserProfile(): React.ReactElement {
  const { username = '' } = useParams();
  const { data, isLoading, error } = useGetUserProfile(username, {
    query: { enabled: Boolean(username) },
  });

  if (isLoading) return <p style={{ color: 'var(--text-secondary)' }}>Loading…</p>;
  if (error) return <p style={{ color: 'var(--danger)' }}>{errorMessage(error)}</p>;
  if (!data) return <p>User not found.</p>;

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-3xl font-bold">{data.user.display_name}</h1>
        <p style={{ color: 'var(--text-secondary)' }}>@{data.user.username}</p>
      </header>

      {data.readme_html && (
        <article
          className="themed-card p-6"
          dangerouslySetInnerHTML={{ __html: data.readme_html }}
        />
      )}

      <section>
        <h2 className="text-2xl font-semibold mb-4">Published machines</h2>
        <div className="grid gap-4 sm:grid-cols-2">
          {data.machines.map((machine) => (
            <MachineCard key={machine.public_id} machine={machine} />
          ))}
        </div>
        {data.machines.length === 0 && (
          <p style={{ color: 'var(--text-secondary)' }}>No published machines yet.</p>
        )}
      </section>
    </div>
  );
}
